module.exports = __webpack_public_path__ + "media/images/common/my_nav_4-cd2bf2e4194089003453e2ccfd5f941c.png";